module.exports = __webpack_public_path__ + "static/index/assets/img/code.404a225a.png";